<dsp-content-card [types]="filterTypes$ | async" [loading]="loading$ | async">
  <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [fullWidth]="(isMobile$ | async)"
    [size]="(isMobile$ | async) ? sizeSmall : sizeMedium" *dsp-content-filter [id]="'cash-flow-period-filter'"
    [label]="'Month/Quarter'" placeholder="Pick One" [multiselectable]="false" [options]="periodFilterOptions"
    [(ngModel)]="period" (valueChange)="onChangePeriod($event)" [clearable]="false">
  </atlas-field-select>


  <ng-container *ngIf="isMobile$ | async">

    <atlas-field [widthValue]="270" [fullWidth]="(isMobile$ | async)" *dsp-content-filter
      [size]="(isMobile$ | async) ? sizeSmall : sizeMedium">
      <atlas-field-label>Select date</atlas-field-label>
      <input [(ngModel)]="asAt" atlasInput [min]="minDate$ | async" [max]="maxDate$ | async"
        [Datepicker]="picker1748417509968" placeholder="Day Month Year" (ngModelChange)="onChangeAsAt($event)"
        [readonly]="true" />
      <atlas-field-suffix>
        <datepicker-toggle [datepicker]="picker1748417509968"></datepicker-toggle>
      </atlas-field-suffix>
      <datepicker #picker1748417509968 [startAt]="null" [startView]="'month'" [xPosition]="'end'" [yPosition]="'below'">
      </datepicker>
    </atlas-field>

  </ng-container>

  <ng-container *ngIf="!(isMobile$ | async)">
    <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
      [id]="'cash-flow-year-filter'" [label]="'As At Year'" placeholder="Pick One" [multiselectable]="false"
      [options]="yearFilterOptions$ | async" [disabled]="!(years$ | async).length" [(ngModel)]="year"
      (valueChange)="onChangeYear($event)" [clearable]="false">
    </atlas-field-select>

    <!-- <ng-container *ngIf="period[ 0 ] === 'month'"> -->
    <ng-container *ngIf="period === 'month'">

      <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
        [id]="'cash-flow-month-filter'" [label]="'As At Month'" placeholder="Pick One" [multiselectable]="false"
        [options]="monthFilterOptions$ | async" [disabled]="!(months$ | async).length" [(ngModel)]="month"
        (valueChange)="onChangeMonth($event)" [clearable]="false">
      </atlas-field-select>
    </ng-container>

    <ng-container *ngIf="period === 'quarter'">

      <atlas-field-select [style.--radius-xsmall]="'4px'" [widthValue]="270" [size]="sizeMedium" *dsp-content-filter
        [id]="'cash-flow-quarter-filter'" [label]="'As At Quarter'" placeholder="Pick One" [multiselectable]="false"
        [options]="quarterFilterOptions$ | async" [disabled]="!(quarters$ | async).length" [(ngModel)]="quarter"
        (valueChange)="onChangeQuarter($event)" [clearable]="false">
      </atlas-field-select>
    </ng-container>
  </ng-container>

  <div dsp-content>
    <div class="row" *ngIf="!(isMobile$ | async) && (data$ | async)?.length">
      <div class="columns">
        <div class="dsp-title-container">

          <atlas-icon [icon]="'icon-webpage-24'" size="large" color="primary" [alt]="'Cash Flow Summary'">
          </atlas-icon>

          <h3 class="mos-u-display--inline-block mos-u-spacer--margin-none mos-u-spacer--padding-left-sm">
            {{ period=== 'month' ? 'Monthly' : 'Quarterly' }} Cash Flow Summary

          </h3>
          <atlas-icon *ngIf="(notes$ | async)?.cashflow !== undefined"
            class="mos-u-spacer--margin-left-xxsm dsp-cashflow-tooltip-trigger" [haloTooltipWithArrow]="true"
            [haloTooltip]="(notes$ | async)?.cashflow" [haloTooltipPosition]="'right'" [haloTooltipShowDelay]="100"
            [id]="'cash-flow-note-icon'" [size]="'small'" [icon]="'c-info'" [collection]="'user-interface'"
            [alt]="'info'">
          </atlas-icon>
        </div>
        <p [id]="'cash-flow-as-at-date'" class="dsp-subtitle">
          as at end of {{ date$ | async }}
        </p>
      </div>
      <div class="columns shrink" [style.margin-left]="'auto'">
        <atlas-dropdown #cashFlowDropdown="atlasDropdown" [id]="'toggle-cash-flow-export'" [iconSize]="sizeMedium"
          [icon]="'more_vert'" [placement]="dropdownPlacementLeftStart" [iconButtonAlt]="'More options'"
          [iconAriaTitle]="'More options'" [triggerType]="dropdownTriggerTypeIconButton">
          <atlas-menu [style.display]="'block'" [style.max-width]="'fit-content'">
            <atlas-menu-item (click)="cashFlowDropdown.menu?.closeMenu($event); onExportPDF()">
              <a [id]="'cash-flow-download'">
                Export as PDF
              </a>
            </atlas-menu-item>
            <atlas-menu-item (click)="cashFlowDropdown.menu?.closeMenu($event); onExportCSV()">
              <a [id]="'cash-flow-export'">
                Export as CSV
              </a>
            </atlas-menu-item>
          </atlas-menu>
        </atlas-dropdown>
      </div>
    </div>
    <div *ngIf="(data$ | async)?.length" class="mos-u-spacer--padding-bottom-xlg">
      <atlas-table [customSort]="true">

        <thead atlas-table-header #header>

          <tr atlas-table-row>
            <th atlas-table-header-cell *ngFor="let col of headers; let i = index" [columnDef]="col"
              [style.text-align]="i > 0 ? 'right' : 'left'" (click)="onSort(col.column, header.sortOption.direction)">
              {{ col.displayLabel }}
            </th>
          </tr>
        </thead>
        <tbody atlas-table-body>
          <tr halo-table-row *ngFor="let row of data$ | async">

            <td atlas-table-cell>
              {{ row.fund }}
            </td>
            <td atlas-table-cell class="mos-u-text-right ">
              {{ row.openingValue && row.openingValue !== 0 ? (row.openingValue | decimal) : '-' }}
            </td>
            <td atlas-table-cell class="mos-u-text-right ">
              {{ row.netCashFlow && row.netCashFlow !== 0 ? (row.netCashFlow | decimal) : '-' }}
            </td>
            <td atlas-table-cell class="mos-u-text-right ">
              {{ row.netChange && row.netChange !== 0 ? (row.netChange | decimal) : '-' }}
            </td>
            <td atlas-table-cell class="mos-u-text-right ">
              {{ row.closingValue && row.closingValue !== 0 ? (row.closingValue | decimal) : '-' }}
            </td>

          </tr>
        </tbody>
      </atlas-table>
      <div class="mos-u-spacer--padding-top-sm mos-u-spacer--padding-bottom-sm">
        <span class="mos-u-footnote">
          * Cash Flow Summary calculated utilizing Redemption / Sell Price
        </span>
      </div>
    </div>
    <div *ngIf=" (data$ | async)?.length===0" class="mos-u-align-center--both" [style.height.px]="100">
      <h3>No data for selected date.</h3>
    </div>
  </div>
</dsp-content-card>